
  export default {
    name: `MarketplacePage`,
    components: {},
    data() {
      return {}
    },
    methods: {}
  }
